import { useState } from 'react'

function SubtaskList({
  subtasks = [],
  users = [],
  onToggle,
  onAdd,
  onDelete,
  editable = false,
  loading = false,
}) {
  const [newSubtask, setNewSubtask] = useState('')
  const [newAssignee, setNewAssignee] = useState('')

  const handleAdd = (e) => {
    e.preventDefault()
    if (!newSubtask.trim()) return
    onAdd(newSubtask.trim(), newAssignee || null)
    setNewSubtask('')
    setNewAssignee('')
  }

  const getUser = (userId) => users.find(u => u.id === userId)

  const getInitials = (name) => {
    if (!name) return '?'
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }

  const completedCount = subtasks.filter(s => s.is_completed).length
  const totalCount = subtasks.length

  if (!editable && totalCount === 0) {
    return null
  }

  return (
    <div className="subtask-list">
      {totalCount > 0 && (
        <div className="subtask-header" style={{ marginBottom: '0.5rem' }}>
          <span className="text-sm text-muted">
            Subtasks ({completedCount}/{totalCount})
          </span>
        </div>
      )}

      <div className="subtask-items" style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
        {subtasks
          .sort((a, b) => (a.order_position || 0) - (b.order_position || 0))
          .map(subtask => {
            const assignee = subtask.assigned_to ? getUser(subtask.assigned_to) : null
            return (
              <div
                key={subtask.id}
                className="subtask-item"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.25rem 0',
                }}
              >
                <input
                  type="checkbox"
                  checked={subtask.is_completed}
                  onChange={() => onToggle(subtask.id)}
                  disabled={loading}
                  style={{ cursor: 'pointer' }}
                />
                <span
                  style={{
                    flex: 1,
                    textDecoration: subtask.is_completed ? 'line-through' : 'none',
                    color: subtask.is_completed ? 'var(--gray-400)' : 'var(--gray-700)',
                    fontSize: '0.875rem',
                  }}
                >
                  {subtask.title}
                </span>
                {assignee && (
                  <span
                    title={assignee.name || assignee.email}
                    style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '50%',
                      background: 'var(--primary)',
                      color: 'white',
                      fontSize: '0.625rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    {getInitials(assignee.name || assignee.email)}
                  </span>
                )}
                {editable && (
                  <button
                    type="button"
                    onClick={() => onDelete(subtask.id)}
                    className="btn btn-ghost btn-sm"
                    style={{
                      padding: '0.125rem 0.25rem',
                      fontSize: '0.75rem',
                      color: 'var(--gray-400)',
                    }}
                    title="Remove subtask"
                  >
                    &times;
                  </button>
                )}
              </div>
            )
          })}
      </div>

      {editable && (
        <form onSubmit={handleAdd} style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <input
            type="text"
            value={newSubtask}
            onChange={(e) => setNewSubtask(e.target.value)}
            placeholder="Add a subtask..."
            className="form-input"
            style={{
              flex: 1,
              minWidth: '150px',
              padding: '0.375rem 0.5rem',
              fontSize: '0.875rem',
            }}
          />
          {users.length > 0 && (
            <select
              value={newAssignee}
              onChange={(e) => setNewAssignee(e.target.value)}
              className="form-input"
              style={{
                padding: '0.375rem 0.5rem',
                fontSize: '0.875rem',
                minWidth: '120px',
              }}
            >
              <option value="">Unassigned</option>
              {users.map(user => (
                <option key={user.id} value={user.id}>
                  {user.name || user.email}
                </option>
              ))}
            </select>
          )}
          <button
            type="submit"
            className="btn btn-secondary btn-sm"
            disabled={!newSubtask.trim() || loading}
          >
            Add
          </button>
        </form>
      )}
    </div>
  )
}

export default SubtaskList
